import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-confirmation-modal-with-reason',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="modal-backdrop fade show" (click)="onCancel()"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            @if (icon) { <i [class]="icon + ' me-2'"></i> }
            {{ title }}
          </h5>
          <button type="button" class="btn-close" (click)="onCancel()" [disabled]="processing" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{ message }}</p>
          <div class="mb-0">
            <label for="modalReason" class="form-label">
              {{ reasonLabel }}
              @if (reasonRequired) { <span class="text-danger">*</span> }
            </label>
            <textarea
              id="modalReason"
              class="form-control"
              rows="3"
              [(ngModel)]="reason"
              [placeholder]="reasonPlaceholder">
            </textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="processing">
            {{ cancelLabel }}
          </button>
          <button
            type="button"
            [class]="'btn btn-' + variant"
            (click)="onConfirm()"
            [disabled]="processing || (reasonRequired && !reason.trim())">
            @if (processing) {
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            }
            {{ processing ? processingLabel : confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
`
})
export class ConfirmationModalWithReasonComponent {
  @Input() title = 'Confirm Action';
  @Input() message = 'Are you sure you want to proceed?';
  @Input() confirmLabel = 'Confirm';
  @Input() cancelLabel = 'Cancel';
  @Input() processingLabel = 'Processing...';
  @Input() variant: 'warning' | 'danger' | 'primary' = 'warning';
  @Input() icon = '';
  @Input() processing = false;
  @Input() reasonLabel = 'Reason';
  @Input() reasonPlaceholder = 'Enter a reason...';
  @Input() reasonRequired = false;

  reason = '';

  @Output() confirmed = new EventEmitter<string>();
  @Output() cancelled = new EventEmitter<void>();

  onConfirm(): void {
    this.confirmed.emit(this.reason.trim());
  }

  onCancel(): void {
    if (!this.processing) {
      this.cancelled.emit();
    }
  }
}
